export default "__VITE_ASSET__CiRcO$NQ__"